const expenseCopy = {
  "es": {
    "Análisis de gastos": "Análisis de gastos",
    "Descubre dónde se va tu dinero.": "Descubre dónde se va tu dinero.",
    "Revisa tus gastos recurrentes y compara tus categorías.": "Revisa tus gastos recurrentes y compara tus categorías.",
    "Visualiza cómo se distribuyen tus gastos por categoría.": "Visualiza cómo se distribuyen tus gastos por categoría.",
    "Período de análisis": "Período de análisis",
    "Exportar análisis CSV": "Exportar análisis CSV",
    "Exportar": "Exportar",
    "Cargando tus gastos…": "Cargando tus gastos…",
    "Gastos ·": "Gastos ·",
    "{count} movimientos registrados": "{count} movimientos registrados",
    "{count} movimiento registrado": "{count} movimiento registrado",
    "Mayor gasto": "Mayor gasto",
    "Sin gastos registrados": "Sin gastos registrados",
    "Categorías": "Categorías",
    "Con gastos en este período": "Con gastos en este período",
    "¿En qué estás gastando?": "¿En qué estás gastando?",
    "Distribución de tus gastos por categoría": "Distribución de tus gastos por categoría",
    "{percent}% del total": "{percent}% del total",
    "No hay gastos registrados en este período.": "No hay gastos registrados en este período.",
    "BRIEFY te sugiere": "BRIEFY te sugiere",
    "Revisa tus gastos recurrentes y busca oportunidades de ahorro.": "Revisa tus gastos recurrentes y busca oportunidades de ahorro.",
    "Gastos destacados": "Gastos destacados",
    "Los cinco movimientos de mayor importe": "Los cinco movimientos de mayor importe",
    "Sin descripción": "Sin descripción",
    "Tus gastos aparecerán aquí cuando los registres.": "Tus gastos aparecerán aquí cuando los registres.",
    "Consejos para reducir gastos": "Consejos para reducir gastos",
    "Compara alternativas en las categorías con mayor gasto.": "Compara alternativas en las categorías con mayor gasto.",
    "Negocia descuentos con proveedores frecuentes.": "Negocia descuentos con proveedores frecuentes.",
    "Evita recargos por mora y define un presupuesto por categoría.": "Evita recargos por mora y define un presupuesto por categoría.",
    "Esta Semana": "Esta Semana",
    "Este Mes": "Este Mes",
    "Este Año": "Este Año",
    "Categoría": "Categoría",
    "Monto": "Monto",
    "Porcentaje": "Porcentaje",
    "TOTAL": "TOTAL",
    "analisis_gastos": "analisis_gastos",
    "📦 Compras/Inventario": "📦 Compras/Inventario",
    "🏢 Alquiler": "🏢 Alquiler",
    "💡 Servicios Públicos": "💡 Servicios Públicos",
    "📱 Internet/Teléfono": "📱 Internet/Teléfono",
    "👥 Nómina": "👥 Nómina",
    "🏛️ Impuestos": "🏛️ Impuestos",
    "🛡️ Seguros": "🛡️ Seguros",
    "🚗 Transporte": "🚗 Transporte",
    "📣 Marketing": "📣 Marketing",
    "🔧 Mantenimiento": "🔧 Mantenimiento",
    "🗃️ Suministros": "🗃️ Suministros",
    "💻 Software": "💻 Software",
    "🏦 Comisiones Bancarias": "🏦 Comisiones Bancarias",
    "💳 Préstamos": "💳 Préstamos",
    "📋 Otros Gastos": "📋 Otros Gastos"
  },
  "en": {
    "Análisis de gastos": "Expense Analysis",
    "Descubre dónde se va tu dinero.": "Find out where your money goes.",
    "Revisa tus gastos recurrentes y compara tus categorías.": "Review recurring expenses and compare categories.",
    "Visualiza cómo se distribuyen tus gastos por categoría.": "See how expenses are distributed by category.",
    "Período de análisis": "Analysis Period",
    "Exportar análisis CSV": "Export Analysis CSV",
    "Exportar": "Export",
    "Cargando tus gastos…": "Loading Your Expenses…",
    "Gastos ·": "Expenses ·",
    "{count} movimientos registrados": "{count} recorded transactions",
    "{count} movimiento registrado": "{count} recorded transaction",
    "Mayor gasto": "Largest Expense",
    "Sin gastos registrados": "No Recorded Expenses",
    "Categorías": "Categories",
    "Con gastos en este período": "With Expenses in This Period",
    "¿En qué estás gastando?": "Where Is Your Money Going?",
    "Distribución de tus gastos por categoría": "Expenses by Category",
    "{percent}% del total": "{percent}% of the total",
    "No hay gastos registrados en este período.": "No expenses recorded in this period.",
    "BRIEFY te sugiere": "BRIEFY Suggests",
    "Revisa tus gastos recurrentes y busca oportunidades de ahorro.": "Review recurring expenses and look for ways to save.",
    "Gastos destacados": "Largest Expenses",
    "Los cinco movimientos de mayor importe": "The Five Largest Transactions",
    "Sin descripción": "No Description",
    "Tus gastos aparecerán aquí cuando los registres.": "Your expenses will appear here when you record them.",
    "Consejos para reducir gastos": "Tips to Reduce Expenses",
    "Compara alternativas en las categorías con mayor gasto.": "Compare alternatives in the categories with the highest spending.",
    "Negocia descuentos con proveedores frecuentes.": "Negotiate discounts with regular suppliers.",
    "Evita recargos por mora y define un presupuesto por categoría.": "Avoid late fees and set a budget for each category.",
    "Esta Semana": "This Week",
    "Este Mes": "This Month",
    "Este Año": "This Year",
    "Categoría": "Category",
    "Monto": "Amount",
    "Porcentaje": "Percentage",
    "TOTAL": "TOTAL",
    "analisis_gastos": "expense_analysis",
    "📦 Compras/Inventario": "📦 Purchases/Inventory",
    "🏢 Alquiler": "🏢 Rent",
    "💡 Servicios Públicos": "💡 Utilities",
    "📱 Internet/Teléfono": "📱 Internet/Phone",
    "👥 Nómina": "👥 Payroll",
    "🏛️ Impuestos": "🏛️ Taxes",
    "🛡️ Seguros": "🛡️ Insurance",
    "🚗 Transporte": "🚗 Transport",
    "📣 Marketing": "📣 Marketing",
    "🔧 Mantenimiento": "🔧 Maintenance",
    "🗃️ Suministros": "🗃️ Supplies",
    "💻 Software": "💻 Software",
    "🏦 Comisiones Bancarias": "🏦 Bank Fees",
    "💳 Préstamos": "💳 Loans",
    "📋 Otros Gastos": "📋 Other Expenses"
  },
  "pt": {
    "Análisis de gastos": "Análise de despesas",
    "Descubre dónde se va tu dinero.": "Descubra para onde vai seu dinheiro.",
    "Revisa tus gastos recurrentes y compara tus categorías.": "Revise suas despesas recorrentes e compare categorias.",
    "Visualiza cómo se distribuyen tus gastos por categoría.": "Veja como suas despesas se distribuem por categoria.",
    "Período de análisis": "Período de análise",
    "Exportar análisis CSV": "Exportar análise CSV",
    "Exportar": "Exportar",
    "Cargando tus gastos…": "Carregando suas despesas…",
    "Gastos ·": "Despesas ·",
    "{count} movimientos registrados": "{count} movimentos registrados",
    "{count} movimiento registrado": "{count} movimento registrado",
    "Mayor gasto": "Maior despesa",
    "Sin gastos registrados": "Nenhuma despesa registrada",
    "Categorías": "Categorias",
    "Con gastos en este período": "Com despesas neste período",
    "¿En qué estás gastando?": "Onde você está gastando?",
    "Distribución de tus gastos por categoría": "Distribuição das despesas por categoria",
    "{percent}% del total": "{percent}% do total",
    "No hay gastos registrados en este período.": "Não há despesas registradas neste período.",
    "BRIEFY te sugiere": "BRIEFY sugere",
    "Revisa tus gastos recurrentes y busca oportunidades de ahorro.": "Revise suas despesas recorrentes e busque oportunidades de economia.",
    "Gastos destacados": "Despesas em destaque",
    "Los cinco movimientos de mayor importe": "Os cinco movimentos de maior valor",
    "Sin descripción": "Sem descrição",
    "Tus gastos aparecerán aquí cuando los registres.": "Suas despesas aparecerão aqui quando forem registradas.",
    "Consejos para reducir gastos": "Dicas para reduzir despesas",
    "Compara alternativas en las categorías con mayor gasto.": "Compare alternativas nas categorias com maiores despesas.",
    "Negocia descuentos con proveedores frecuentes.": "Negocie descontos com fornecedores frequentes.",
    "Evita recargos por mora y define un presupuesto por categoría.": "Evite multas por atraso e defina um orçamento por categoria.",
    "Esta Semana": "Esta semana",
    "Este Mes": "Este mês",
    "Este Año": "Este ano",
    "Categoría": "Categoria",
    "Monto": "Valor",
    "Porcentaje": "Percentual",
    "TOTAL": "TOTAL",
    "analisis_gastos": "analise_despesas",
    "📦 Compras/Inventario": "📦 Compras/Estoque",
    "🏢 Alquiler": "🏢 Aluguel",
    "💡 Servicios Públicos": "💡 Serviços públicos",
    "📱 Internet/Teléfono": "📱 Internet/Telefone",
    "👥 Nómina": "👥 Folha de pagamento",
    "🏛️ Impuestos": "🏛️ Impostos",
    "🛡️ Seguros": "🛡️ Seguros",
    "🚗 Transporte": "🚗 Transporte",
    "📣 Marketing": "📣 Marketing",
    "🔧 Mantenimiento": "🔧 Manutenção",
    "🗃️ Suministros": "🗃️ Suprimentos",
    "💻 Software": "💻 Software",
    "🏦 Comisiones Bancarias": "🏦 Tarifas bancárias",
    "💳 Préstamos": "💳 Empréstimos",
    "📋 Otros Gastos": "📋 Outras despesas"
  },
  "fr": {
    "Análisis de gastos": "Analyse des dépenses",
    "Descubre dónde se va tu dinero.": "Découvrez où va votre argent.",
    "Revisa tus gastos recurrentes y compara tus categorías.": "Examinez vos dépenses récurrentes et comparez les catégories.",
    "Visualiza cómo se distribuyen tus gastos por categoría.": "Visualisez la répartition de vos dépenses par catégorie.",
    "Período de análisis": "Période d’analyse",
    "Exportar análisis CSV": "Exporter l’analyse CSV",
    "Exportar": "Exporter",
    "Cargando tus gastos…": "Chargement de vos dépenses…",
    "Gastos ·": "Dépenses ·",
    "{count} movimientos registrados": "{count} opérations enregistrées",
    "{count} movimiento registrado": "{count} opération enregistrée",
    "Mayor gasto": "Dépense la plus élevée",
    "Sin gastos registrados": "Aucune dépense enregistrée",
    "Categorías": "Catégories",
    "Con gastos en este período": "Avec des dépenses sur cette période",
    "¿En qué estás gastando?": "Où va votre argent ?",
    "Distribución de tus gastos por categoría": "Répartition des dépenses par catégorie",
    "{percent}% del total": "{percent} % du total",
    "No hay gastos registrados en este período.": "Aucune dépense enregistrée sur cette période.",
    "BRIEFY te sugiere": "BRIEFY vous conseille",
    "Revisa tus gastos recurrentes y busca oportunidades de ahorro.": "Examinez vos dépenses récurrentes et cherchez des possibilités d’économies.",
    "Gastos destacados": "Principales dépenses",
    "Los cinco movimientos de mayor importe": "Les cinq opérations les plus importantes",
    "Sin descripción": "Sans description",
    "Tus gastos aparecerán aquí cuando los registres.": "Vos dépenses apparaîtront ici une fois enregistrées.",
    "Consejos para reducir gastos": "Conseils pour réduire les dépenses",
    "Compara alternativas en las categorías con mayor gasto.": "Comparez les options dans les catégories les plus coûteuses.",
    "Negocia descuentos con proveedores frecuentes.": "Négociez des remises avec vos fournisseurs habituels.",
    "Evita recargos por mora y define un presupuesto por categoría.": "Évitez les pénalités de retard et fixez un budget par catégorie.",
    "Esta Semana": "Cette semaine",
    "Este Mes": "Ce mois-ci",
    "Este Año": "Cette année",
    "Categoría": "Catégorie",
    "Monto": "Montant",
    "Porcentaje": "Pourcentage",
    "TOTAL": "TOTAL",
    "analisis_gastos": "analyse_depenses",
    "📦 Compras/Inventario": "📦 Achats/Stocks",
    "🏢 Alquiler": "🏢 Loyer",
    "💡 Servicios Públicos": "💡 Services publics",
    "📱 Internet/Teléfono": "📱 Internet/Téléphone",
    "👥 Nómina": "👥 Paie",
    "🏛️ Impuestos": "🏛️ Impôts",
    "🛡️ Seguros": "🛡️ Assurances",
    "🚗 Transporte": "🚗 Transport",
    "📣 Marketing": "📣 Marketing",
    "🔧 Mantenimiento": "🔧 Entretien",
    "🗃️ Suministros": "🗃️ Fournitures",
    "💻 Software": "💻 Logiciels",
    "🏦 Comisiones Bancarias": "🏦 Frais bancaires",
    "💳 Préstamos": "💳 Emprunts",
    "📋 Otros Gastos": "📋 Autres dépenses"
  }
};
export default expenseCopy;
